
<template>
    <div class="courses-single-page pt-4 pb-4 home-bg">
        <div class="container">
            <div class="row">
                <div class="col-lg-8">
                    <div class="content-page-wrap clearfix">
                        <div class="course-single">
                            <div class="content">
                                <div class="author-price">
                                    <div class="author">
                                        <!--
                                        <div class="avatar">
                                            <img v-bind:src="user | s3url" alt="images" style="max-width: 80px">
                                        </div>
                                            -->
                                        <div v-if="user" class="info" style="margin-bottom: 20px;">
                                            <div class="name">
                                                <a href="#">{{ user.firstName }} {{ user.lastName }}</a>
                                            </div>
                                            <div class="job">
                                                {{ user.jobTitle }}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">

                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="content-page-wrap clearfix">
                        <div class="flat-tabs" style="margin-top: 0px; padding-top: 0px;">
                            <ul class="tab-title type1 clearfix">
                                <li class="item-title overview accent-primary-bg accent-primary-tx">
                                    <span class="inner">MY PROGRESS</span>
                                </li>
                                <li class="item-title curriculum accent-primary-bg accent-primary-tx">
                                    <span class="inner">PAST COURSES</span>
                                </li>
                                <li class="item-title instructor accent-primary-bg accent-primary-tx">
                                    <span class="inner">PROFILE</span>
                                </li>
                            </ul>
                            <div class="tab-content-wrap">
                                <div class="tab-content">
                                    <div class="item-content">
                                        <div class="widget widget-class-start">
                                            <div class="widget-title">
                                                My Progress
                                            </div>
                                            <div class="content">
                                                <div v-if="courses.length == 0" class="content-course-list">
                                                    <p>
                                                        You're not currently working on any courses.
                                                    </p>
                                                    <br />
                                                    <router-link class="btn btn-site-secondary" to="/courses">Browse Courses</router-link>
                                                </div>
                                                <div v-else class="content-course-list">
                                                    <course-card-component v-for="course in courses" v-if="course.userAssigned && !course.completed" :course="course" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-content">
                                    <div class="item-content">
                                        <div class="widget widget-class-start">
                                            <div class="widget-title">
                                                Completed course
                                            </div>
                                            <div class="content">
                                                <div v-if="courses.length == 0" class="content-course-list">
                                                    <p>
                                                        You've not completed any courses yet.
                                                    </p>
                                                    <br />
                                                    <router-link class="btn btn-site-secondary" to="/courses">Browse Courses</router-link>
                                                </div>
                                                <div v-else class="content-course-list">
                                                    <course-card-component v-for="course in courses" v-if="course.userAssigned && course.completed" :course="course" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-content">
                                    <div class="item-content">
                                        <div v-if="user" class="question-sg text clearfix">
                                            <div class="title">
                                                <a class="main-title-text">

                                                    Member Personal Details
                                                </a>
                                            </div>
                                            <div>
                                                <label>Name</label>
                                                <input v-model="user.firstName" type="text" />
                                            </div>
                                            <div>
                                                <label>Surname</label>
                                                <input v-model="user.lastName" type="text" />
                                            </div>
                                            <div>
                                                <label>Email</label>
                                                <input v-model="user.email" class="disabled" disabled type="text" />
                                            </div>
                                            <div>
                                                <label>Job Title</label>
                                                <input v-model="user.jobTitle" type="text" />
                                            </div>
                                            <div>
                                                <label>Professional Qualification Title</label>
                                                <input v-model="user.qualification" type="text" />
                                            </div>


                                            <div v-if="hasDivisions()">
                                                <label>Division</label>
                                                <select v-model="user.division">
                                                    <option v-for="division in divisions" :value="division">{{ division }}</option>
                                                </select>
                                            </div>



                                            <div v-show="siteId == 10">
                                                <div class="tooltip-wrapper" style="position: relative;">
                                                    <label>ID Number</label>
                                                    <div class="tooltip-icon" data-toggle="tooltip" data-placement="top" title="Id number is displayed on issued certificates" style="position: absolute; right: -30px; top: 0; width: fit-content;">
                                                        <i class="fa fa-info-circle"></i>
                                                    </div>
                                                </div>
                                                <input readonly v-model="user.idNumber" type="text" />
                                                <label class="mt-3">Please contact support to update your ID number: <br /><a href="mailto:trainme@estudysa.co.za" type="">trainme@estudysa.co.za</a></label>
                                            </div>
                                            <div>
                                                <br />
                                                <button v-on:click="save" class="btn btn-site-primary">Save</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div><!-- courses-single -->

</template>

<style scoped>

    .cpd-submit {
        color: white;
        background-color: #3f4c99;
        padding: 20px 30px;
        border-radius: 50px;
        font-size: 16px;
    }

    .user-map-button {
        background-color: #3f4c99;
        padding: 60px;
        border-radius: 26px;
        text-align: center;
        font-size: 19px;
        box-shadow: 5px 5px 20px;
    }

        .user-map-button h2 {
            color: white;
        }

    .suggested-course {
        margin-top: 65px;
    }

        .suggested-course .category {
            top: 31% !important
        }

        .suggested-course .add-cart-a {
            font-size: 11px;
        }

        .suggested-course .add-cart {
            top: 55% !important;
        }

        .suggested-course .name a {
            font-size: 14px !important;
        }

        .suggested-course .name {
            top: 57% !important;
        }

        .suggested-course .border-bt {
            bottom: 141px !important;
        }

        .suggested-course .review {
            bottom: 54px !important;
        }

    .request li:before {
        left: 16px !important;
    }

    .request li {
        margin-left: 30px;
    }

    .progress-square {
        border-radius: 0px !important;
    }

    .tabs-count-3 ul {
        margin-bottom: -2px !important;
    }

    .tabs-count-3 .tab-title li {
        width: 33% !important;
        border-radius: 20px;
    }

    @media (max-width: 767px) {
        .tabs-count-3 .tab-title li {
            width: 49.59% !important;
        }
    }

    @media (max-width: 533px) {
        .tabs-count-3 .tab-title li {
            width: 100% !important;
        }
    }

    .tab-title.type1 li.active:after, .tab-title.type1 li:hover:after {
        z-index: 10;
    }


    .course-single .content .author-price {
        padding-bottom: 0px !important;
        border-bottom: none;
    }

    .btn-info {
        box-shadow: 0 8px 6px -6px black;
    }
</style>

<script>
    export default {
        name: 'Dashboard',
        components: {

        },
        data: function () {
            return {
                courses: []
            }
        },
        computed: {
            user() {
                return this.$store.state.user;
            },
            siteDesign() {
                return this.$store.state.siteDesign;
            },
            siteId() {
                return this.$store.getters.getSiteId;
            },
            divisions() {
                return this.$store.state.divisions;
            }
        },
        methods: {
            async save() {
                try {
                    // fetch data from a url endpoint
                    const response = await this.web('/users', "Updating user details", this.user);
                    this.$store.commit("setUser", this.user);
                } catch (error) {
                    console.error("error", error);
                }
            },
            hasDivisions() {
                return this.divisions && this.divisions.length;
            }
        },
        updated() {
            $('[data-toggle="tooltip"]').tooltip()
        },
        async mounted() {

            this.courses = await this.web("/courses?filters=user");
            
            this.$store.commit("breadCrumbs", { "/dashboard": "Dashboard" });

            $('.flat-tabs').each(function () {
                var list = "",
                    title = $(this).find('.item-title'),
                    titleWrap = $(this).children('.tab-title');

                $(this).find('.tab-title li').filter(':first').addClass('active');
                $(this).find('.tab-content-wrap').children().hide().filter(':first').addClass('active').show();

                $(this).find('.tab-title li').on('click', function (e) {
                    var
                        idx = $(this).index(),
                        content = $(this).closest('.flat-tabs').find('.tab-content-wrap').children().eq(idx);

                    $(this).addClass('active').siblings().removeClass('active');
                    content.fadeIn('slow').addClass('active').siblings().hide().removeClass('active');

                    e.preventDefault();
                });
            });
            $(".bg-header").css("background-image", "url(https://fabricfour.blob.core.windows.net/mhslearning-upload/" + this.siteDesign.homePage.bannerFileName + ")");

            //if auto-enrollment is on, enroll and navigate to the next single available course
            debugger;
            console.log(window.location.href);
            console.log(window.location.href.indexOf("#loggedin"));
            if (this.siteDesign.autoEnrollment && window.location.href.indexOf("#loggedin") > -1) {

                let allCourses = await this.web("/courses?filters=none");
                let openCourses = allCourses.filter(x => x.completed === false);
                console.log(allCourses);
                console.log(openCourses);
                if (openCourses.length == 1) {
                    let course = openCourses[0];
                    if (course.userAssigned) {
                        //navigate
                        console.log("Navigate to course");
                        this.$router.push(`/courses/details/${course.id}`);
                    }
                    else {
                        //enroll
                        console.log("Enrol in course");
                        this.$router.push(`/courses/details/${course.id}#enrol`);
                    }
                }
            }
        },
        async created() {
        }
    }

</script>